var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderIconLightMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 18,
    viewBox: "0 0 40 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0834 5.28173C33.9397 6.2302 33.0829 7.27716 31.4429 7.27716H25.509L26.108 3.31737H32.0388C33.6788 3.31737 34.2247 4.33478 34.0834 5.28173ZM25.0131 10.5635H29.8997L32.2535 16.2505C32.4816 16.827 32.9853 17.1975 33.892 17.1975C35.0416 17.1975 35.9733 16.352 36.1264 15.3354C36.1764 14.9967 36.1233 14.6589 35.9874 14.3892L34.1763 9.98848C36.6114 9.10743 37.8836 7.37867 38.1944 5.31279C38.6388 2.37269 36.9027 0 31.913 0H24.5148C23.3621 0 22.282 0.912864 22.1148 2.03027L20.1304 15.1679C19.9632 16.2831 20.7677 17.1975 21.9196 17.1975C23.0723 17.1975 24.154 16.2831 24.3211 15.1679L25.0131 10.5635Z",
    fill: "#00ACFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8861 7.5921H9.44422C8.47581 7.5921 7.57527 8.35338 7.43241 9.29121C7.28956 10.2298 7.96279 10.9911 8.93042 10.9911H15.3715C16.3431 10.9911 17.2429 10.2298 17.3833 9.29121C17.5262 8.35338 16.8545 7.5921 15.8861 7.5921ZM17.0021 0.193377H3.02837C2.06074 0.193377 1.16099 0.956179 1.01893 1.89478C0.87686 2.83491 1.55009 3.59694 2.51772 3.59694H16.4923C17.4599 3.59694 18.3581 2.83491 18.5009 1.89478C18.6398 0.956179 17.9713 0.193377 17.0021 0.193377Z",
    fill: "#73EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIconLightMob);
export default __webpack_public_path__ + "static/media/header_icon_light_mob.da5bab6a6fcfcb607a093701d6fb1824.svg";
export { ForwardRef as ReactComponent };